import { AwardCategory } from "@enums/awardCategory";

export const awardCategoryOptions = [
  { value: AwardCategory.WiseArtsChoice, label: "Wise Arts Choice" },
  { value: AwardCategory.PhygitalWinner, label: "Phygital Winner" },
  { value: AwardCategory.DigitalWinner, label: "Digital Winner" },
  { value: AwardCategory.CollectiveWinner, label: "Collective Winner" },
  { value: AwardCategory.PhotographyWinner, label: "Photography Winner" },
];

export const awardCategoryMap = {
  [AwardCategory.CollectiveWinner]: "Collective Winner",
  [AwardCategory.DigitalWinner]: "Digital Winner",
  [AwardCategory.WiseArtsChoice]: "Wise Arts Choice",
  [AwardCategory.PhotographyWinner]: "Photography Winner",
  [AwardCategory.PhygitalWinner]: "Phygital Winner",
};
